<template>
  <v-chip
    v-if="showChip()"
    outlined
    small
  >
    {{ templateLabel }}
  </v-chip>
</template>
<script>
import { isEmpty, get } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    templateId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['getTemplate']),
    templateLabel() {
      return get(this.getTemplate(this.templateId), 'label', '')
    }
  },
  methods: {
    ...mapActions([ 'ensureTemplate' ]),
    showChip() {
      return !isEmpty(this.templateLabel)
    }
  },
}
</script>
